import React from "react";
import Button from "../../UI/Button/Button";
import Modal from "../../UI/Modal/Modal";

const ErrorHandler = (WrappedComponent) => {
  return (props) => {
    return (
      <div>
        {props.error && (
          <Modal close={props.onClearError}>
            <header>
              <h2>Something went wrong!</h2>
            </header>
            <section>
              <p>
                {
                  "We are extremely sorry for this technical glitch, reporting this would definitely help us to fix this asap."
                }
              </p>
            </section>
            <footer>
              <Button
                href="mailto:maransowthri@gmail.com?Subject=[IMPORTANT]%20Application%20Issue"
                type="Primary"
              >
                Report
              </Button>
              <Button click={props.onClearError} type="Secondary">
                Close
              </Button>
            </footer>
          </Modal>
        )}
        <WrappedComponent {...props} />
      </div>
    );
  };
};

export default ErrorHandler;
